import React, { useRef, useEffect, useState } from 'react'
import { search_icon, vector } from '../../../assets/images'

const SearchBar = ({ placeholder = '', handler = () => {}, inputRefStr = 'search-bar-xs', CloseIconHandler = () =>{}, searchIconClasses = 'left-4 top-5', clearIconClasses = 'right-4 top-4', classes = '', closeIcon = '' ,  inputClasses = 'p-4 pl-10 rounded-md', label = '', labelClasses = '' }) => {
  const searchRef = useRef(inputRefStr)
  const [value , setValue] = useState('')

  useEffect(() => {
    const onEnter = (event) => {
      const curElement = searchRef.current
      if (event.keyCode === 13 && document.activeElement === curElement) {
        const value = curElement.value
        handler(value)
      }
    }
    document.addEventListener('keyup', onEnter)

    return () => document.removeEventListener('keyup', onEnter)
  }, [handler])
      
  return (
    <div className={`relative ${classes}`}>
        { label && <label className={`mb-0 ${labelClasses}`}>{label}</label>}
        <input ref={searchRef} 
          placeholder={placeholder}
          value={value} 
          onChange={(e) => setValue(e.target.value)}
          className={`w-full focus:outline-none focus:border-gray-400 border border-gray-200 font-semibold placeholder-gray-300 ${inputClasses}`} />
        <img src={search_icon} className={`absolute ${searchIconClasses}`} />
        { value && 
          <img 
            src={vector} 
            alt='search-icon-xs' 
            onClick={() => {
              setValue('')
              CloseIconHandler()
            }} 
            className={`absolute ${clearIconClasses}`} /> }
        </div>    
  )
}

export default SearchBar